import { render, staticRenderFns } from "./TournamentEventDraws.vue?vue&type=template&id=1bfb03e8&"
import script from "./TournamentEventDraws.vue?vue&type=script&lang=js&"
export * from "./TournamentEventDraws.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEventDraws.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentEventDraws.vue"
export default component.exports